import * as types from '../action/actionTypes';
import initialState from './initialState';

export default class HolidaysReducer {
    static AllHolidaysReducer(state = initialState.Holidays, action) {
        switch (action.type) {
            case types.GET_HOLIDAY_LIST_SUCCESSFUL: return {
                HolidayList: action.getResponse,
            };
            default : return state; 
        }   
    
    }
    static  GetHolidayReducer(state = initialState.Holiday, action){
        switch (action.type){
            case types.GET_HOLIDAY_SUCCESSFUL: return {
                HolidayDts: action.getResponse,
            };
            default : return state;
        }
    }
    static SaveHolidayReducer(state = initialState.Holiday, action){
        switch (action.type){
            case types.POST_HOLIDAY_SUCCESSFULL: return{
                HolidayDts: action.getResponse,
            };
            default : return state;
        }
    }
}